import { render, staticRenderFns } from "./IconFontWeightBadge.vue?vue&type=template&id=1f8a4b1e"
import script from "./IconFontWeightBadge.vue?vue&type=script&lang=js"
export * from "./IconFontWeightBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports